import { render, staticRenderFns } from "./DocumentosCandidato.vue?vue&type=template&id=28cd9094&scoped=true&"
import script from "./DocumentosCandidato.vue?vue&type=script&lang=js&"
export * from "./DocumentosCandidato.vue?vue&type=script&lang=js&"
import style0 from "./DocumentosCandidato.vue?vue&type=style&index=0&id=28cd9094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cd9094",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VIcon,VRow,VSkeletonLoader,VSpacer})
